import { createSlice } from '@reduxjs/toolkit'
import { revertAll } from './userSlice'

const initialState = {
    myState: null,
}

export const contentSlice = createSlice({
    name: 'content',
    initialState,
    extraReducers: (builder) => builder.addCase(revertAll, () => initialState),
    reducers: {
        setMyState: (state, action) => {
            state.myState = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { 
    setMyState,
} = contentSlice.actions

export default contentSlice.reducer